<div class="full column">
  <div class="field">
    <label soho-label required>{{'Name' | translate}}</label>
    <input soho-input [(ngModel)]="name" />
  </div>
  <div class="field">
    <label soho-label>{{'Description' | translate}}</label>
    <input soho-input [(ngModel)]="description" />
  </div>
<!--  <div class="field">-->
<!--    <input type="checkbox" id="saveAsDefault" soho-checkbox [(ngModel)]="default" />-->
<!--    <label soho-label forCheckBox="true" for="saveAsDefault">{{'Default' | translate}}</label>-->
<!--  </div>-->
</div>
